// Import Components
import App                            from './components/App.vue'
import Activity                       from './components/Activity.vue'
import ActivityList                   from './components/ActivityList.vue'
import ActivityToast                  from './components/ActivityToast.vue'
import Address                        from './components/Address.vue'
import Avatar                         from './components/Avatar.vue'
import BrowserLockout                 from './components/BrowserLockout.vue'
import Changelog                      from './components/Changelog.vue'
import DetailsHeader                  from './components/DetailsHeader.vue'
import Dialog                         from './components/Dialog.vue'
import DialogParent                   from './components/DialogParent.vue'
import EmptyState                     from './components/EmptyState.vue'
import Filter                         from './components/Filter.vue'
import FilterNav                      from './components/FilterNav.vue'
import Gallery                        from './components/Gallery.vue'
import Icon                           from './components/Icon.vue'
import ImageSelect                    from './components/ImageSelect.vue'
import InAppRedirect                  from './components/InAppRedirect.vue'
import InviteCreate                   from './components/InviteCreate.vue'
import InviteDetails                  from './components/InviteDetails.vue'
import InviteList                     from './components/InviteList.vue'
import List                           from './components/List.vue'
import ListFooter                     from './components/ListFooter.vue'
import ListHeader                     from './components/ListHeader.vue'
import Login                          from './components/Login.vue'
import Navigation                     from './components/Navigation.vue'
import NavigationMobile               from './components/NavigationMobile.vue'
import Page                           from './components/Page.vue'
import PageTemplate                   from './components/PageTemplate.vue'
import PeopleDetails                  from './components/PeopleDetails.vue'
import PeopleList                     from './components/PeopleList.vue'
import PrivacyLockout                 from './components/PrivacyLockout.vue'
import PropertyDetails                from './components/PropertyDetails.vue'
import PropertyList                   from './components/PropertyList.vue'
import PropertyManage                 from './components/PropertyManage.vue'
import RoleManage                     from './components/RoleManage.vue'
import RolePermissions                from './components/RolePermissions.vue'
import RoleTemplateDetails            from './components/RoleTemplateDetails.vue'
import RoleTemplateList               from './components/RoleTemplateList.vue'
import RoleTemplateManage             from './components/RoleTemplateManage.vue'
import Settings                       from './components/Settings.vue'
import SettingsProfile                from './components/SettingsProfile.vue'
import SettingsPassword               from './components/SettingsPassword.vue'
import SettingsEmail                  from './components/SettingsEmail.vue'
import SettingsNotifications          from './components/SettingsNotifications.vue'
import SettingsNotificationsSchedule  from './components/SettingsNotificationsSchedule.vue'
import Signout                        from './components/Signout.vue'
import TicketAddImages                from './components/TicketAddImages.vue'
import TicketChat                     from './components/TicketChat.vue'
import TicketCreate                   from './components/TicketCreate.vue'
import TicketDetails                  from './components/TicketDetails.vue'
import TicketList                     from './components/TicketList.vue'
import TicketManageTools              from './components/TicketManageTools.vue'
import TicketNote                     from './components/TicketNote.vue'
import TicketTagManage                from './components/TicketTagManage.vue'
import TicketTagDetails               from './components/TicketTagDetails.vue'
import TicketTagList                  from './components/TicketTagList.vue'
import TimePicker                     from './components/TimePicker.vue'
import Toast                          from './components/Toast.vue'
import UnitList                       from './components/UnitList.vue'
import UnitDetails                    from './components/UnitDetails.vue'
import UnitManage                     from './components/UnitManage.vue'
import UnitTypeManage                 from './components/UnitTypeManage.vue'
import VersionLockout                 from './components/VersionLockout.vue'

import ExternalHeader                 from '../src/components/ExternalHeader.vue'
import ExternalRedirect               from '../src/components/ExternalRedirect.vue'
import ExternalAccountSetup           from '../src/components/ExternalAccountSetup.vue'
import ExternalChangelog              from '../src/components/ExternalChangelog.vue'
import ExternalChangeEmail            from '../src/components/ExternalChangeEmail.vue'
import ExternalKnowledgeBase          from '../src/components/ExternalKnowledgeBase.vue'
import ExternalPasswordReset          from '../src/components/ExternalPasswordReset.vue'
import ExternalPolicy                 from '../src/components/ExternalPolicy.vue'
import ExternalSupport                from '../src/components/ExternalSupport.vue'

export default {     
  App, 
  Activity,
  ActivityList,
  ActivityToast,
  Address,
  Avatar,
  BrowserLockout,
  Changelog,
  DetailsHeader,
  Dialog,
  DialogParent,
  EmptyState,
  Filter,
  FilterNav,
  Gallery,
  Icon,
  ImageSelect,
  InAppRedirect,
  InviteCreate,
  InviteDetails,
  InviteList,
  List,
  ListFooter,
  ListHeader,
  Login,
  Navigation,
  NavigationMobile,
  Page,
  PageTemplate,
  PeopleDetails,
  PeopleList,
  PrivacyLockout,
  PropertyDetails,
  PropertyList,
  PropertyManage,
  RoleManage,
  RolePermissions,
  RoleTemplateDetails,
  RoleTemplateList,
  RoleTemplateManage,
  Settings,
  SettingsProfile,
  SettingsPassword,
  SettingsEmail,
  SettingsNotifications,
  SettingsNotificationsSchedule,
  Signout,
  TicketAddImages,
  TicketChat,
  TicketCreate,
  TicketDetails,
  TicketList,
  TicketManageTools,
  TicketNote,
  TicketTagManage,
  TicketTagDetails,
  TicketTagList,
  TimePicker,
  Toast,
  UnitList,
  UnitDetails,
  UnitManage,
  UnitTypeManage,
  VersionLockout,

  ExternalHeader,
  ExternalRedirect,
  ExternalAccountSetup,
  ExternalChangelog,
  ExternalChangeEmail,
  ExternalKnowledgeBase,
  ExternalPasswordReset,
  ExternalPolicy,
  ExternalSupport
}


// WEBPACK FOOTER //
// ./src/components.js